import {CreateSiteApiDto, SiteApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";
import Address from "../address/Address";

export default class SiteData {

	/**
	 * String using to search site, contains concatenation of name and address.
	 */
	public readonly searchString: string;

	constructor(public readonly address: Address) {
		this.searchString =
			`${address.postcode} ${address.buildingNumber.map(n => `${n}`).getOrElse("")} ${address.street.map(
				s => `${s}`).getOrElse("")} ${address.city.map(c => `${c}`).getOrElse("")} ${address.country}`.toLowerCase();
	}

	static fromJson(json: SiteApiDto): SiteData {
		return new SiteData(Address.fromJson(json.address));
	}

	toJson(): CreateSiteApiDto {
		const json: CreateSiteApiDto = {
			address: this.address.toJson()
		};

		return JsonConverter.removeEmptyFields(json)
	}
}